export default __webpack_public_path__ + "images/secure-icon.ea4da04cce25bb89b9da22359ad1f350.svg";